const notifyme = (n, handleClickNotification) => {
  if (!('Notification' in window)) {
    console.error('This browser does not support desktop notification');
  } else if (Notification.permission === 'granted') {
    var notification = new Notification(n.title, {
      body: n.description
    });
    notification.onclick = () => {
      handleClickNotification(n.id);
    };
  } else if (Notification.permission !== 'denied') {
    Notification.requestPermission().then((permission) => {
      if (permission === 'granted') {
        var notification = new Notification(n.title, {
          body: n.description
        });
        notification.onclick = () => {
          handleClickNotification(n.id);
        };
      }
    });
  }
};

export default notifyme;
